import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";


const styles = StyleSheet.create({
  // page: {
  //   padding: 20,
  //   fontSize: 10,
  //   paddingTop: 80,
  // },
  page: {
    paddingTop: 90,
    paddingBottom: 80,
    paddingHorizontal: 20,
    fontSize: 10,
  },
  section: {
    marginBottom: 10,
  },
  headerContainer: {
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: 20,
    marginBottom: 20
  },
  headerText: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10
  },
  subHeaderText: {
    fontSize: 10,
    fontWeight: "bold",
    //textAlign: "center",
    marginBottom: 5
  },
  table: {
    display: "table",
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
    borderBottomWidth: 0,

  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  tableRowLast: {
    flexDirection: "row",
  },
  //   tableColHeader1: {
  //     width: "30px",
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     fontWeight: "bold",
  //     backgroundColor: "#EEE",
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "center",
  //   },
  //   tableCol1: {
  //     width: "30px",
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "right",
  //   },
  //   tableColHeader: {
  //     width: "100px",
  //     flex: 1,
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     fontWeight: "bold",
  //     backgroundColor: "#EEE",
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "center",
  //   },
  //   tableColHeaderDescription: {
  //     width: "500px",
  //     flex: 2.5,
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     fontWeight: "bold",
  //     backgroundColor: "#EEE",
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "center",
  //   },

  //   tableCol: {
  //     width: "100px",
  //     flex: 1,
  //     borderRightWidth: 1,
  //     borderRightColor: "#000",
  //     padding: 5,
  //     justifyContent: "center",
  //     alignItems: "center",
  //     textAlign: "left",
  //   },

  //  tableColDescription: {
  //   width: "500px",
  //   flex: 2.5,
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "left",       
  //   alignItems: "flex-start",  
  //   justifyContent: "center",  
  // },

  // tableColHeader1: {
  //   width: "30px", // keep S.No column narrow
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   fontWeight: "bold",
  //   backgroundColor: "#EEE",
  //   textAlign: "center",
  // },
  // tableCol1: {
  //   width: "30px", // keep it narrow
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "right",
  // },
  // tableColHeader: {
  //   flex: 1, // Allow responsive layout
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   fontWeight: "bold",
  //   backgroundColor: "#EEE",
  //   textAlign: "center",
  // },
  // tableColHeaderDescription: {
  //   flex: 2.5, // Give more space to Description
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   fontWeight: "bold",
  //   backgroundColor: "#EEE",
  //   textAlign: "center",
  // },
  // tableCol: {
  //   flex: 1, // Responsive width for general cells
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "left",
  // },
  // tableColDescription: {
  //   flex: 2.5, // Give more space to Description
  //   borderRightWidth: 1,
  //   borderRightColor: "#000",
  //   padding: 5,
  //   textAlign: "left",
  // },
  tableColHeader2: {
    width: 35,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableColHeader1: {
    width: 40,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },

  tableCol2: {
    width: 35,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "center",
  },
  tableCol1: {
    width: 40,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "center",
  },
  tableColHeader: {
    width: 70,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableColHeaderApprDate: {
    width: 70,
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableColHeaderProject: {
    width: 80,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableColHeaderSmall: {
    width: 80,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },


  tableColHeaderemp: {
    width: 90,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableColHeaderDescription: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  tableCol: {
    width: 70,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  tableColApprDateRow: {
    width: 70,
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  tableColProject: {
    width: 80,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  tableColSmall: {
    width: 80,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },

  tableColSmallemp: {
    width: 90,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  tableColDescription: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },

  //list of employee tasks
  emppage: {
    padding: 20,
    fontSize: 10,
  },
  empheaderText: {
    fontSize: 15,
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: 10,
  },
  emptableContainer: {
    display: "table",
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
    borderBottomWidth: 0,
  },
  emptableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  emptableColHeader1: {
    width: 35, // S.No
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableCol1: {
    width: 35, // S.No row
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "center",
  },
  emptableColHeaderProject: {
    width: "20%", // Project column
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableColProject: {
    width: "20%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  emptableColHeaderEmp: {
    width: "80%", // Employee Name column
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableColEmp: {
    width: "80%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  emptableColHeaderhrs: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  emptableColHeaderActhrs: {
    width: "8%",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },

  emptableCol1hrs: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },
  emptableCol1Totalhrs: {
    width: "8%",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },

  //list of Project tasks

  prjpage: {
    padding: 20,
    fontSize: 10,
  },
  prjheaderText: {
    fontSize: 15,
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: 10,
  },
  prjtableContainer: {
    display: "table",
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
    borderTopWidth: 1,
    borderBottomWidth: 0,
  },
  prjtableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  prjtableColHeader1: {
    width: 34, // S.No
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  prjtableCol1: {
    width: 35, // S.No row
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "center",
  },
  prjtableColHeaderProject: {
    width: "100%", // Project column
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  prjtableColProject: {
    width: "100%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  prjtableColHeaderEmp: {
    width: "80%", // Employee Name column
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  prjtableColEmp: {
    width: "80%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "left",
  },
  prjtableColHeaderhrs: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  prjtableColHeaderTActhrs: {
    width: "8%",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontWeight: "bold",
    backgroundColor: "#EEE",
    textAlign: "center",
  },

  prjtableCol1hrs: {
    width: "8%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },
  prjtableCol1hrsTActhrs: {
    width: "8%",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "right",
  },
  prjtableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  prjtableCol1: {
    width: 34, // S.No row
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    textAlign: "center",
  },


  /* HEADER */
  headerWrapper: {
    position: "absolute",
    top: 20,
    left: 20,
    right: 20,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
  },

  headerImage: {
    width: "100%",
    height: 60,
    objectFit: "contain",
  },
  /* FOOTER */
  footerWrapper: {
    position: "absolute",
    bottom: 20,
    left: 5,
    right: 5,     // forces full width
    height: 80,
    justifyContent: "center",
    alignItems: "center",
  },

  footerImage: {
    width: "100%",
    height: "100%",
  },

});

// ✅ GROUP BY EMPLOYEE
const groupByEmployee = (data) => {
  const groups = {};
  data.forEach((item) => {
    const emp = item.EmployeeName || "Unknown";
    if (!groups[emp]) groups[emp] = [];
    groups[emp].push(item);
  });
  return groups;
};

// Split data: 20 on first page, 26 afterwards

// const paginateData = (data) => {
//   const pages = [];

//   const firstPageCount = 7;
//   const otherPageCount = 9;

//   // First page
//   pages.push(data.slice(0, firstPageCount));

//   // Remaining pages
//   for (let i = firstPageCount; i < data.length; i += otherPageCount) {
//     pages.push(data.slice(i, i + otherPageCount));
//   }

//   return pages;
// };

// const PAGE_HEIGHT = 595; // A4 landscape approx height

// const HEADER_HEIGHT = 70;
// const FOOTER_HEIGHT = 80;
// const TABLE_HEADER_HEIGHT = 25;
// const FIRST_PAGE_EXTRA = 80; // your headerTextContainer

// const AVAILABLE_HEIGHT_FIRST =
//   PAGE_HEIGHT - HEADER_HEIGHT - FOOTER_HEIGHT - TABLE_HEADER_HEIGHT - FIRST_PAGE_EXTRA;

// const AVAILABLE_HEIGHT_OTHER =
//   PAGE_HEIGHT - HEADER_HEIGHT - FOOTER_HEIGHT - TABLE_HEADER_HEIGHT;

const PAGE_HEIGHT = 375;
let AVAILABLE_HEIGHT = PAGE_HEIGHT - 90 - 80;
const estimateRowHeight = (desc) => {
  const charsPerLine = 30;
  const lineHeight = 12;
  const padding = 10;

  const lines = Math.ceil(desc.length / charsPerLine);
  return lines * lineHeight + padding;
};

const paginateData = (data) => {
  const pages = [];
  let currentPage = [];
  let usedHeight = 0;
  // let firstpage=true;
  data.forEach((row) => {
    const rowHeight = estimateRowHeight(row.Description || "");
    //new
    // if(firstpage)
    // {
    //   AVAILABLE_HEIGHT=AVAILABLE_HEIGHT-40;
    // }
    if (usedHeight + rowHeight > AVAILABLE_HEIGHT) {
      pages.push(currentPage);
      currentPage = [];
      usedHeight = 0;
    }
    // firstpage=false;
    currentPage.push(row);
    usedHeight += rowHeight;
  });

  if (currentPage.length) pages.push(currentPage);

  return pages;
};

const PSRreport = ({
  data = [],
  filters = {},
  projectName = "",
  managerName = "",
  employeeTaskData = [],
  projectTaskData = [],
  footerHeight
}) => {

  const groupedData = groupByEmployee(data);
  const allPages = [];


  const formatDate = (inputDate) => {
    if (!inputDate) return "";
    const [year, month, day] = inputDate.split("-");
    return `${day}-${month}-${year}`;
  };

  // 👇 All pages combined here to calculate correct page numbers
  let previousEmployee = "";
  let slno = 0;
  // ✅ MAIN LOGIC (Employee-wise pages)
  Object.entries(groupedData).forEach(([employee, empData], empIndex) => {

    const pages = paginateData(empData);
    // const pages = paginateData(data);
    // --- Main paginated pages ---
    pages.forEach((pageData, pageIndex) => {
      allPages.push(
        <Page
          size="A4"
          orientation="landscape"
          // style={styles.page}
          style={{
            paddingBottom: footerHeight,
            paddingTop: 90,
            paddingBottom: 80,
            paddingHorizontal: 20,
            fontSize: 10,
          }}
          key={`main-${pageIndex}`}
        >
          {/* Header */}
          <View fixed style={styles.headerWrapper}>
            {filters.HeaderImg && (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
                style={styles.headerImage}
              />
            )}
          </View>

          {/* {pageIndex === 0 && ( */}
          {allPages.length === 0 && (
            <View style={styles.headerTextContainer}>
              <Text style={styles.headerText}>
                {`Project Report - ${filters.EmployeeID}
              ${filters.FromDate && filters.ToDate
                    ? `(${formatDate(filters.FromDate)} to ${formatDate(filters.ToDate)})`
                    : ""}`}
              </Text>
              <Text style={styles.subHeaderText}>{`Project: ${projectName}`}</Text>
              {/* {managerName !== "" && (
              <Text style={styles.subHeaderText}>{`Manager: ${managerName}`}</Text>
            )}
            <Text style={styles.subHeaderText}>{"Comp -> Completed ||Appr -> Approved"}</Text> */}
              <View style={{ flexDirection: "row", justifyContent: "space-between" }}>

                {managerName !== "" && (
                  <Text style={styles.subHeaderText}>{`Manager: ${managerName}`}</Text>
                )}
                <Text style={styles.subHeaderText}>
                  E.Hrs - Estimated Hours
                </Text>
              </View>

              <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                <Text style={styles.subHeaderText}>
                  {"Comp -> Completed | Appr -> Approved"}
                </Text>
                <Text style={styles.subHeaderText}>
                  A.Hrs - Actual Hours
                </Text>
              </View>

            </View>
          )}

          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableColHeader2}>SL#</Text>
              <Text style={styles.tableColHeader}>Date</Text>
              <Text style={styles.tableColHeaderProject}>Project</Text>
              <Text style={styles.tableColHeaderemp}>Employee</Text>
              <Text style={styles.tableColHeaderDescription}>Description</Text>
              <Text style={styles.tableColHeader1}>E.Hrs</Text>
              <Text style={styles.tableColHeader1}>A.Hrs</Text>
              <Text style={styles.tableColHeader}>Comp Date</Text>
              <Text style={styles.tableColHeaderSmall}>Appr By</Text>
              <Text style={styles.tableColHeaderApprDate}>Appr Date</Text>
            </View>

            {pageData.map((row, rowIndex) => {
              if (previousEmployee !== row.EmployeeName) {
                slno = 1;
                previousEmployee = row.EmployeeName;
              } else {
                slno += 1;
              }
              //  const isFirstRow = rowIndex === 0;
              return (

                <View
                  key={rowIndex}
                  style={[
                    styles.tableRow,
                    // isFirstRow && { borderTopWidth: 1 } // ✅ add top border
                  ]}
                  //  style={styles.tableRow}
                  wrap={false}>
                  <Text style={styles.tableCol2}>{slno}</Text>
                  <Text style={styles.tableCol}>{row.DATE}</Text>
                  <Text style={styles.tableColProject}>{row.ProjectCode}</Text>

                  {/* <Text style={styles.tableColProject}>{row.ProjectCode} || {row.ProjectName}</Text> */}
                  <Text style={styles.tableColSmallemp}>{previousEmployee}</Text>
                  <Text style={styles.tableColDescription}>{row.Comments}</Text>
                  <Text style={styles.tableCol1}>{row.EStimatedHourse}</Text>
                  <Text style={styles.tableCol1}>{row.ActualHourse}</Text>
                  <Text style={styles.tableCol}>{row.CurrectCompletedDate}</Text>
                  <Text style={styles.tableColSmall}>{row.ManagerCode}</Text>
                  <Text style={styles.tableColApprDateRow}>{row.ApprovedDate}</Text>
                </View>
              )
            })}
          </View>

          {/* Footer */}
          <View fixed
            // style={styles.footerWrapper}
            style={{
              position: "absolute",
              bottom: 20,
              left: 5,
              right: 5,
              height: footerHeight, // 🔥 dynamic
            }}
          >
            {filters.FooterImg && (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
                // style={styles.footerImage}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            )}
          </View>
        </Page>
      );
    });
  })
  // --- Employee Tasks Page ---
  allPages.push(
    <Page size="A4"
      orientation="landscape"
      // style={styles.page} 
      style={{
        paddingBottom: footerHeight,
        paddingTop: 90,
        paddingBottom: 80,
        paddingHorizontal: 20,
        fontSize: 10,
      }}
      key="employee-tasks">
      <View fixed style={styles.headerWrapper}>
        {filters.HeaderImg && (
          <Image
            src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
            style={styles.headerImage}
          />
        )}
      </View>

      <Text style={styles.empheaderText}>Employee Tasks Efforts</Text>

      <View style={styles.emptableContainer}>
        <View style={styles.emptableRow}>
          <Text style={styles.emptableColHeader1}>SL#</Text>
          <Text style={styles.emptableColHeaderProject}>Project</Text>
          <Text style={styles.emptableColHeaderEmp}>Employee Name</Text>
          <Text style={styles.emptableColHeaderhrs}>Total E.Hrs</Text>
          <Text style={styles.emptableColHeaderActhrs}>Total A.Hrs</Text>
        </View>

        {employeeTaskData.map((row, index) => (
          <View key={index} style={styles.emptableRow}>
            <Text style={styles.emptableCol1}>{index + 1}</Text>
            <Text style={styles.emptableColProject}>{row.ProjectName}</Text>
            <Text style={styles.emptableColEmp}>{row.EmployeeName}</Text>
            {/* <Text style={styles.emptableCol1hrs}>{row.TotalEstimatedHours.toFixed(2)}</Text>
            <Text style={styles.emptableCol1Totalhrs}>{row.TotalActualHours.toFixed(2)}</Text> */}
            <Text style={styles.emptableCol1hrs}>{row.TotalEstimatedHours}</Text>
            <Text style={styles.emptableCol1Totalhrs}>{row.TotalActualHours}</Text>
          </View>
        ))}
      </View>

      {/* Footer */}
      <View fixed
        // style={styles.footerWrapper}
        style={{
          position: "absolute",
          bottom: 20,
          left: 5,
          right: 5,
          height: footerHeight, // 🔥 dynamic
        }}
      >
        {filters.FooterImg && (
          <Image
            src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
            // style={styles.footerImage}
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        )}
      </View>

    </Page>
  );

  // --- Project Tasks Page ---
  allPages.push(
    <Page size="A4"
      orientation="landscape"
      // style={styles.page}
      style={{
        paddingBottom: footerHeight,
        paddingTop: 90,
        paddingBottom: 80,
        paddingHorizontal: 20,
        fontSize: 10,
      }}
      key="project-tasks">
      <View fixed style={styles.headerWrapper}>
        {filters.HeaderImg && (
          <Image
            src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
            style={styles.headerImage}
          />
        )}
      </View>

      <Text style={styles.prjheaderText}>Project Tasks Efforts</Text>

      <View style={styles.prjtableContainer}>
        <View style={styles.prjtableRow}>
          <Text style={styles.prjtableColHeader1}>SL#</Text>
          <Text style={styles.prjtableColHeaderProject}>Project</Text>
          {/* <Text style={styles.prjtableColHeaderEmp}>Employee Name</Text> */}
          <Text style={styles.prjtableColHeaderhrs}>Total E.Hrs</Text>
          <Text style={styles.prjtableColHeaderTActhrs}>Total A.Hrs</Text>
        </View>

        {projectTaskData.map((row, index) => (
          <View key={index} style={styles.prjtableRow}>
            <Text style={styles.prjtableCol1}>{index + 1}</Text>
            <Text style={styles.prjtableColProject}>{row.ProjectName}</Text>
            {/* <Text style={styles.prjtableColEmp}>{row.EmployeeName}</Text> */}
            <Text style={styles.prjtableCol1hrs}>{row.TotalEstimatedHours}</Text>
            <Text style={styles.prjtableCol1hrsTActhrs}>{row.TotalActualHours}</Text>
          </View>
        ))}
      </View>
      {/* Footer */}
      <View fixed
        // style={styles.footerWrapper}
        style={{
          position: "absolute",
          bottom: 20,
          left: 5,
          right: 5,
          height: footerHeight, // 🔥 dynamic
        }}
      >
        {filters.FooterImg && (
          <Image
            src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
            // style={styles.footerImage}
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        )}
      </View>
    </Page>

  );

  return (
    //   <Document>
    //     {pages.forEach((pageData, pageIndex) => (
    //       <Page size="A4" orientation="landscape" style={styles.page} key={pageIndex}>
    //         {pageIndex === 0 && (
    //           // <View style={styles.headerContainer}>
    //           //   <Text style={styles.headerText}>

    //           //     {`TimeSheet - ${filters.EmployeeID} (${monthNames[filters.Month - 1]} - ${filters.Year})`}
    //           //   </Text>
    //           // </View>
    //           <View style={styles.headerTextContainer}>
    //             <Text style={styles.headerText}>
    // {`Project Status Report - ${filters.EmployeeID}
    // ${
    //   filters.FromDate && filters.ToDate
    //   ? `(${formatDate(filters.FromDate)} to ${formatDate(filters.ToDate)})`
    //     : ""
    // }`}

    //               {/* {`Project Status Report - ${filters.EmployeeID} (${monthNames[filters.Month - 1]} - ${filters.Year})`} */}
    //             </Text>
    //             <Text style={styles.subHeaderText}>
    //               {`Project: ${projectName}`}
    //             </Text>
    //             {/* <Text style={styles.subHeaderText}>
    //         {`Manager: ${managerName}`}
    //       </Text> */}
    //             {managerName !== "" && (
    //               <Text style={styles.subHeaderText}>
    //                 {`Manager: ${managerName}`}
    //               </Text>
    //             )}
    //             <Text style={styles.subHeaderText}>
    //               {"Comp -> Completed ||Appr -> Approved"}
    //             </Text>
    //           </View>

    //         )}

    //         {/* Table Header */}
    //         <View style={styles.table}>
    //           <View style={styles.tableRow}>
    //             <Text style={styles.tableColHeader1}>S.No</Text>
    //             <Text style={styles.tableColHeader}>Date</Text>
    //             <Text style={styles.tableColHeaderSmall}>Project</Text>
    //             <Text style={styles.tableColHeaderemp}>Employee</Text>
    //             <Text style={styles.tableColHeaderDescription}>Description</Text>
    //             <Text style={styles.tableColHeader1}>Est Hrs</Text>
    //             <Text style={styles.tableColHeader1}>Act Hrs</Text>
    //             <Text style={styles.tableColHeader}>Comp Date</Text>
    //             <Text style={styles.tableColHeaderSmall}>Appr By</Text>
    //             <Text style={styles.tableColHeader}>Appr Date</Text>
    //           </View>

    //           {pageData.map((row, rowIndex) => {
    //             const isLast = rowIndex === pageData.length - 1;
    //             return (
    //               <View
    //                 key={rowIndex}
    //                 style={isLast ? styles.tableRowLast : styles.tableRow}
    //               >
    //                 <Text style={styles.tableCol1}>{rowIndex + 1}</Text>
    //                 <Text style={styles.tableCol}>{row.Date}</Text>
    //                 <Text style={styles.tableColSmall}>{row.ProjectCode}</Text>
    //                 <Text style={styles.tableColSmallemp}>{row.EmployeeName}</Text>
    //                 <Text style={styles.tableColDescription}>{row.Description}</Text>
    //                  <Text style={styles.tableCol1}>{row.EStimatedHourse}</Text>
    //                  <Text style={styles.tableCol1}>{row.ActualHourse}</Text>
    //                 <Text style={styles.tableCol}>{row.CurrectCompletedDate}</Text>
    //                 <Text style={styles.tableColSmall}>{row.ManagerCode}</Text>
    //                 <Text style={styles.tableCol}>{row.ApprovedDate}</Text>
    //               </View>
    //             );
    //           })}
    //         </View>
    //         <View
    //           fixed
    //           style={{
    //             position: "absolute",
    //             bottom: 10,
    //             left: 0,
    //             right: 0,
    //             textAlign: "center",
    //             fontSize: 10,
    //           }}
    //         >
    //           <Text>Page {pageIndex + 1} of {pages.length}</Text>
    //         </View>
    //       </Page>
    //     ))}

    //          <Page size="A4" orientation="landscape" style={styles.page} key="employee-tasks">
    //       <Text style={styles.empheaderText}>Employee Tasks</Text>

    //       <View style={styles.emptableContainer}>
    //         <View style={styles.emptableRow}>
    //           <Text style={styles.emptableColHeader1}>S.No</Text>
    //           <Text style={styles.emptableColHeaderProject}>Project</Text>
    //           <Text style={styles.emptableColHeaderEmp}>Employee Name</Text>
    //           <Text style={styles.emptableColHeaderhrs}>Total E.Hrs</Text>
    //           <Text style={styles.emptableColHeaderhrs}>Total A.Hrs</Text>
    //         </View>

    //         {employeeTaskData.map((row, index) => (
    //           <View key={index} style={styles.emptableRow}>
    //             <Text style={styles.emptableCol1}>{index + 1}</Text>
    //             <Text style={styles.emptableColProject}>{row.ProjectName}</Text>
    //             <Text style={styles.emptableColEmp}>{row.EmployeeName}</Text>
    //             <Text style={styles.emptableCol1hrs}>{row.TotalEstimatedHours}</Text>
    //             <Text style={styles.emptableCol1hrs}>{row.TotalActualHours}</Text>
    //           </View>
    //         ))}
    //       </View>

    //       {/* Footer */}
    //       <View
    //         fixed
    //         style={{
    //           position: "absolute",
    //           bottom: 10,
    //           left: 0,
    //           right: 0,
    //           textAlign: "center",
    //           fontSize: 10,
    //         }}
    //       >
    //           <Text>Page {pageIndex + 1} of {pages.length}</Text>
    //       </View>
    //     </Page>


    //       <Page size="A4" orientation="landscape" style={styles.page} key="employee-tasks">
    //       <Text style={styles.prjheaderText}>Project Tasks</Text>

    //       <View style={styles.prjtableContainer}>
    //         <View style={styles.prjtableRow}>
    //           <Text style={styles.prjtableColHeader1}>S.No</Text>
    //           <Text style={styles.prjtableColHeaderProject}>Project</Text>
    //           <Text style={styles.prjtableColHeaderhrs}>Total E.Hrs</Text>
    //           <Text style={styles.prjtableColHeaderhrs}>Total A.Hrs</Text>
    //         </View>

    //         {projectTaskData.map((row, index) => (
    //           <View key={index} style={styles.prjtableRow}>
    //             <Text style={styles.prjtableCol1}>{index + 1}</Text>
    //             <Text style={styles.prjtableColProject}>{row.ProjectName}</Text>
    //             <Text style={styles.prjtableCol1hrs}>{row.TotalEstimatedHours}</Text>
    //             <Text style={styles.prjtableCol1hrs}>{row.TotalActualHours}</Text>
    //           </View>
    //         ))}
    //       </View>

    //       <View
    //         fixed
    //         style={{
    //           position: "absolute",
    //           bottom: 10,
    //           left: 0,
    //           right: 0,
    //           textAlign: "center",
    //           fontSize: 10,
    //         }}
    //       >
    //           <Text>Page {pageIndex + 1} of {pages.length}</Text>
    //       </View>
    //     </Page>

    //   </Document>
    <Document>
      {allPages.map((page, index) =>
        React.cloneElement(page, {
          children: (
            <>
              {page.props.children}
              <View
                fixed
                style={{
                  position: "absolute",
                  bottom: 10,
                  left: 0,
                  right: 0,
                  textAlign: "center",
                  fontSize: 10,
                }}
              >
                <Text>Page {index + 1} </Text>
              </View>
            </>
          ),
        })
      )}
    </Document>
  );
};

export default PSRreport;
